export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";